import * as React from 'react';

function SvgRecCommition(props) {
  return (
    <svg width={12} height={12} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.8 3.9h.15C2.527 3.9 3 4.373 3 4.95v5.25c0 .577-.473 1.05-1.05 1.05H1.8c-.577 0-1.05-.473-1.05-1.05V4.95c0-.577.473-1.05 1.05-1.05zM6 .75c.578 0 1.05.473 1.05 1.05v8.4c0 .577-.472 1.05-1.05 1.05-.578 0-1.05-.473-1.05-1.05V1.8c0-.577.472-1.05 1.05-1.05zm4.2 6c.577 0 1.05.473 1.05 1.05v2.4c0 .577-.473 1.05-1.05 1.05-.578 0-1.05-.473-1.05-1.05V7.8c0-.577.472-1.05 1.05-1.05z" />
    </svg>
  );
}

export default SvgRecCommition;
